import cx from 'classnames';
import React from 'react';

import * as styles from './styles.less';

interface Props {
    className?: string;
    letters: string[];
    selectedLetter?: string;
    onSelectLetter(letter: string): void;
}

const LetterNav: React.SFC<Props> = props => (
    <nav className={ cx(styles.root, props.className) }>
        <ul className={ styles.list }>
            { props.letters.map(letter => (
                <li
                    key={ letter }
                    className={ cx(styles.letter, {
                        [styles.letterSelected]: props.selectedLetter === letter,
                    }) }
                >
                    <button
                        className={ styles.button }
                        onClick={ props.onSelectLetter.bind(null, letter) }
                    >
                        <span className={ styles.letterChar }>{ letter }</span>
                        <svg className={ styles.close } xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                            <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/>
                        </svg>
                    </button>
                </li>
            )) }
        </ul>
    </nav>
);

export default LetterNav;
